/* Theowater — storefront behaviour
   Ported from the drinktheowater.com landing page (nav scroll, reveal
   observer, manifesto modal, Klaviyo waitlist) and extended with the
   mobile drawer, quantity stepper and product gallery. */

(function () {
  'use strict';

  /* ── fixed nav: solid background after scroll ─────────── */
  var nav = document.getElementById('nav');
  if (nav) {
    var onScroll = function () {
      nav.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── mobile drawer ────────────────────────────────────── */
  var toggle = document.querySelector('.nav-toggle');
  if (toggle) {
    toggle.addEventListener('click', function () {
      var open = document.body.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.style.overflow = open ? 'hidden' : '';
    });
    document.querySelectorAll('.nav-drawer a').forEach(function (a) {
      a.addEventListener('click', function () {
        document.body.classList.remove('nav-open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ── reveal on scroll ─────────────────────────────────── */
  var reveals = document.querySelectorAll('.reveal');
  if (reveals.length) {
    reveals.forEach(function (r) { r.classList.add('hidden'); });
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.remove('hidden');
            e.target.classList.add('visible');
            observer.unobserve(e.target);
          }
        });
      }, { threshold: 0.08 });
      reveals.forEach(function (r) { observer.observe(r); });
    }
    setTimeout(function () {
      reveals.forEach(function (r) {
        var box = r.getBoundingClientRect();
        if (box.top < window.innerHeight) {
          r.classList.remove('hidden');
          r.classList.add('visible');
        }
      });
    }, 150);
  }

  /* ── manifesto modal ──────────────────────────────────── */
  var modal = document.getElementById('manifestoModal');
  if (modal) {
    var modalClose = document.getElementById('modalClose');
    var modalVideo = document.getElementById('modalVideo');
    var videoId = modal.getAttribute('data-video-id') || '';

    var openModal = function () {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      if (videoId && modalVideo && !modalVideo.querySelector('iframe')) {
        modalVideo.innerHTML =
          '<iframe src="https://www.youtube.com/embed/' + videoId +
          '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      }
    };
    var closeModal = function () {
      modal.classList.remove('active');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('.manifesto-trigger').forEach(function (el) {
      el.addEventListener('click', function (e) { e.preventDefault(); openModal(); });
    });
    if (modalClose) modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });
  }

  /* ── quantity steppers ────────────────────────────────── */
  document.querySelectorAll('.qty').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var next = parseInt(input.value || '1', 10) + step;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ── product gallery thumbs ───────────────────────────── */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) {
          b.setAttribute('aria-current', b === btn ? 'true' : 'false');
        });
      });
    });
  }

  /* ── Klaviyo waitlist ─────────────────────────────────── */
  var form = document.getElementById('waitlistForm');
  if (form) {
    var cfg = (window.Theowater && window.Theowater.klaviyo) || {};
    var emailEl = document.getElementById('waitlistEmail');
    var nameEl = document.getElementById('waitlistName');
    var msg = document.getElementById('waitlistMsg');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (emailEl.value || '').trim();
      var name = nameEl ? (nameEl.value || '').trim() : '';

      var fail = function (text) {
        msg.style.color = 'var(--gold-light)';
        msg.textContent = text;
      };

      if (nameEl && !name) return fail('Please enter your name.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Please enter a valid email.');
      if (!cfg.company_id || !cfg.list_id) return fail('Waitlist is not connected yet.');

      var btn = form.querySelector('button');
      var label = btn.textContent;
      btn.disabled = true;
      btn.textContent = '…';

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + cfg.company_id, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: { profile: { data: { type: 'profile', attributes: { email: email, first_name: name } } } },
            relationships: { list: { data: { type: 'list', id: cfg.list_id } } }
          }
        })
      }).then(function (res) {
        if (res.ok || res.status === 202) {
          form.reset();
          msg.style.color = 'var(--aqua)';
          msg.textContent = "You're on the list. We'll be in touch with first access.";
        } else {
          fail('Something went wrong. Please try again.');
        }
      }).catch(function () {
        fail('Something went wrong. Please try again.');
      }).finally(function () {
        btn.disabled = false;
        btn.textContent = label;
      });
    });
  }
})();
